/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Component} from '@angular/core';
import {BaseFieldType} from 'compob2b-libs';

@Component({
    selector: 'app-phone-mask',
    templateUrl: './phone-mask.component.html',
    standalone: false
})
export class PhoneMaskComponent extends BaseFieldType {

}
